<template>
    <div class="container-fluid container-fill">
        <div class="row">
            <div class="paper">
                <h2>
                    <router-link to="/Admin"><font-awesome-icon :icon="['fa', 'arrow-left']" class="pointer olive-green-text" /></router-link>
                    Hosted Files
                    <font-awesome-icon :icon="['fa', 'sync-alt']" v-on:click="RefreshDataTable()" class="olive-green-text pointer" style="margin-right:0.5rem;" />
                    <font-awesome-icon :icon="['fa', 'plus']" class="pointer olive-green-text " @click="CreateHostedFileButton" />
                    <span class="AddOrEditModal">

                        <b-modal ref="component-modal" title="Add or Edit Hosted File" hide-footer>
                            <b-container fluid>
                                <b-form @submit="AddOrEditHostedFile">
                                    <b-row>
                                        <b-col cols="12"><b>Name:</b></b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12" style="margin-bottom: 1rem"><b-form-input v-model="name" type="name" required></b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12"><b>Label:</b></b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12" style="margin-bottom: 1rem"><b-form-input v-model="label" type="label" required></b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12"><b>Grouping:</b></b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12" style="margin-bottom: 1rem"><b-form-input v-model="grouping" type="label" required></b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12"><b>Permission:</b></b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12" style="margin-bottom: 1rem"><b-form-input v-model="permission" type="label" required></b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12">
                                            <div v-if="FileID == null">
                                                <b-row>
                                                    <b-col cols="12"><b>Upload File:</b></b-col>
                                                </b-row>
                                                <b-form ref="uploadFile">
                                                    <b-form-group>
                                                        <b-form-file drop-placeholder="Drop image here..."
                                                                     name="File"
                                                                     class="form-control" />
                                                    </b-form-group>
                                                </b-form>
                                            </div>
                                            <div v-else>

                                                <b-row>
                                                    <b-col cols="12"><b>Uploaded File:</b></b-col>
                                                    <b-col cols="9"><b>{{FileName}}</b></b-col>
                                                    <b-col cols="1"><font-awesome-icon v-on:click="ViewDocument(FileID, FileName,FileName)" :icon="['fa', 'file-pdf']" style="font-size: 24px; margin-right:0.5rem;" class="pointer"></font-awesome-icon></b-col>
                                                    <b-col cols="1"><font-awesome-icon v-on:click="DownloadFile(FileID,FileName)" :icon="['fa', 'download']" style="font-size: 24px; margin-right:0.5rem;" class="pointer"></font-awesome-icon></b-col>
                                                    <b-col cols="1"><font-awesome-icon :icon="['fa', 'exchange-alt']" style="font-size:24px" class="pointer" @click="FileID = null" /></b-col>
                                                </b-row>
                                            </div>
                                        </b-col>
                                    </b-row>
                                    <b-row class="modal-btn-row">
                                        <div class="modal-btn-row-div">
                                            <b-button size="md" variant="secondary" @click="Cancel()">
                                                CANCEL
                                            </b-button>
                                            <b-button size="md" variant="primary" type="submit">
                                                CONFIRM
                                            </b-button>
                                        </div>
                                    </b-row>
                                </b-form>
                            </b-container>
                        </b-modal>
                    </span>
                </h2>
                <vuetable :fields="HostedFileTableOptions.Fields"
                          :data-manager="DataManager"
                          pagination-path=""
                          :api-mode="false"
                          ref="datatable">
                    <template slot="HostedFileActions" scope="props">
                        <div class="HostedFileActionsDiv">
                            <b-row no-gutters>
                                <b-col md="auto">
                                    <font-awesome-icon :icon="['fa', 'edit']" style="font-size: 24px; margin-right:1rem;" class="pointer orange " @click="EditHostedFileButton(props.rowData)" />
                                </b-col>
                                <b-col md="auto">
                                    <ActionButtonWithIcon :requires-confirmation="true"
                                                          confirmation-string="WARNING: You are about to delete this hosted file.  Are you sure?"
                                                          endpoint="HostedFiles/DeleteHostedFile"
                                                          :payload="{Id: props.rowData.Id}"
                                                          :perform-global-update="false"
                                                          button-variant="success"
                                                          button-string=""
                                                          button-size="md"
                                                          v-on:success="RefreshDataTable"
                                                          icon-prefix="fa"
                                                          icon-suffix="trash-alt"
                                                          icon-color="red"
                                                          method="POST" />
                                </b-col>
                            </b-row>
                        </div>
                    </template>
                </vuetable>
                <DocumentViewer ref="document-viewer-modal-component" :reviewing="false" />
            </div>
        </div>
    </div>
</template>

<script>
    //import components
    import Vuetable from 'vuetable-2/src/components/Vuetable'
    // import helper functions
    import ActionButtonWithIcon from '../Admin/ActionButtonWithIcon.vue';
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faSyncAlt);
    import { faExchangeAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faExchangeAlt);
    import { faDownload } from '@fortawesome/free-solid-svg-icons';
    library.add(faDownload);
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);
    import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faTrashAlt);
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
    library.add(faArrowLeft);
    import { EventBus } from '../../services/event-bus.js';
    import DocumentViewer from "../Core/RecordComponents/DocumentViewer.vue";
    export default {
        name: "HostedFile",
        created() {
        },
        props: [],
        data: function () {
            return {
                name: '',
                label: '',
                grouping: '',
                HostedFiles: [],
                Id: null,
                permission: '',
                File: null,
                FileID: '',
                FileName: '',
                HostedFileTableOptions: {
                    Fields: [
                        {
                            name: 'Name',
                            title: 'Name',
                            sortField: 'Name'
                        },
                        {
                            name: 'Label',
                            title: 'Label',
                            sortField: 'Label'
                        },
                        {
                            name: 'Grouping',
                            title: 'Grouping',
                            sortField: 'Grouping'
                        },
                        {
                            name: 'Permission',
                            title: 'Permission',
                            sortField: 'Permission'
                        },
                        {
                            name: 'UpdatedAt',
                            title: "Updated",
                            sortField: 'UpdatedAt',
                            callback: 'formatUTCDate|MM/DD/YY',
                        },
                        {
                            name: '__slot:HostedFileActions',
                            title: 'Actions'
                        }
                    ]
                }
            };
        },
        methods: {
            EditHostedFileButton(rowData) {
                this.Id = rowData.Id;
                this.name = rowData.Name;
                this.label = rowData.Label;
                this.permission = rowData.Permission;
                this.grouping = rowData.Grouping;
                this.FileID = rowData.FileID;
                this.FileName = rowData.FileName;
                this.$refs['component-modal'].show();
            },
            CreateHostedFileButton(rowData) {
                this.Id = "";
                this.name = "";
                this.label = "";
                this.FileID = null
                this.permission = "";
                this.grouping = "";
                this.File = null;
                this.FileName = '';
                this.$refs['component-modal'].show();
            },
            Cancel() {
                this.$refs['component-modal'].hide();
            },
            RefreshDataTable() {
                this.GetHostedFiles();
            },
            GetHostedFiles() {
                this.$MasterAPI.ExecuteRequest("GET", "HostedFiles/GetHostedFiles", {}, this.GetHostedFilesSuccess, () => { }, true);
            },
            GetHostedFilesSuccess(response) {
                this.HostedFiles = response.data.data;
                this.$refs.datatable.refresh();
            },
            AddOrEditHostedFile(e) {
                e.preventDefault();
                let form = this.$refs['uploadFile'];
                let formData = new FormData(form);
                //formData.append("File", this.File);
                formData.append("Name", this.name);
                formData.append("Label", this.label);
                formData.append("Grouping", this.grouping);
                formData.append("Permission", this.permission);
                if (this.Id == "") {
                    this.$MasterAPI.ExecuteRequest("POST", "HostedFiles/CreateHostedFile", formData, this.AddOrEditHostedFileSuccess, () => { }, true);
                }

                else {
                    formData.append("Id", this.Id);
                    this.$MasterAPI.ExecuteRequest("POST", "HostedFiles/EditHostedFile",formData, this.AddOrEditHostedFileSuccess, () => { }, true);
                }
            },
            AddOrEditHostedFileSuccess(response) {
                this.RefreshDataTable();
                this.$refs["component-modal"].hide();
            },
            ViewDocument(pdfFileID, formLabel, documentName) {
                this.$refs['document-viewer-modal-component'].ShowViewerModal(pdfFileID, formLabel, documentName);
            },
            DownloadFile(fileID, fileName) {
                this.$MasterAPI.ExecuteFileRequest("Core/Files/GetFileContent/" + fileName, { FileID: fileID });
            },
            DataManager(sortOrder, pagination) {
                let dataset = this.filteredList(this.HostedFiles);
                if (dataset.length > 0) {
                    if (sortOrder.length > 0) {
                        if (sortOrder[0].direction == 'asc') {
                            var firstComp = 1;
                            var secondComp = -1;
                        } else {
                            var firstComp = -1;
                            var secondComp = 1
                        }
                        return dataset.sort((a, b) => (this.$FindProperty(a, sortOrder[0].sortField) > this.$FindProperty(b, sortOrder[0].sortField)) ? firstComp : secondComp);
                    } else {
                        return dataset;
                    }

                } else {
                    return [];
                }
            },
            filteredList(inputData) {
                let vm = this;
                let tData = inputData
                if (tData == null) {
                    return [];
                }
                let tFields = vm.$refs["datatable"].tableFields;
                let visibleData = [];
                tData.forEach(function (row, index) {
                    let rowData = [];
                    tFields.forEach(function (field) {
                        rowData.push(vm.$refs.datatable.renderNormalField(field, row));
                    })
                    visibleData.push(inputData[index]);
                });
                return visibleData;
            },
            formatUTCDate(value, fmt = 'D MMM YYYY') {
                return (value == null)
                    ? ''
                    : moment.utc(value, 'YYYY-MM-DD HH:mm:ss').local().format(fmt)
            },
        },
        components: {
            ActionButtonWithIcon,
            Vuetable,
            DocumentViewer
        },
        computed: {

        },
        mounted() {
            this.GetHostedFiles();
        }
    }
</script>

<style scoped>
</style>